import axios from 'axios'
import config from './config'
const uuidv1 = require('uuid/v1')


export default {
  getServerExpiration (survName) {
    //let options = { headers: { 'Content-Type': fileType, 'x-amz-acl': 'public-read' } }
    let endpoint = config.AWS_LAMBDA_GET_SERVER_EXPIRATION
    let payload = {
      id: survName
    }
    return axios.post(endpoint, payload)
      .then((res) => {
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject("Failed to get server expiration date")
      })
  },
  getSignedURLUpload (fileName, fileType, directory, thumbnail) {
    //let options = { headers: { 'Content-Type': fileType, 'x-amz-acl': 'public-read' } }
    let guid = uuidv1()
    let endpoint = config.AWS_LAMBDA_GETSIGNEDURL_UPLOAD_ENDPOINT
    let payload = {
      fileName: fileName,
      filePath: directory + '/' + guid + '-' + fileName,
      contentType: fileType,
      thumbnail: thumbnail,
      thumbnailName: directory + '/' + guid + '-thumbnail-' + fileName
    }
    return axios.post(endpoint, payload)
      .then((res) => {
        return Promise.resolve(res.data.body.url || '/')
      })
      .catch((err) => {
        return Promise.reject('/')
      })
  },
  getSignedURLDownload(fileKey){
    let endpoint = config.AWS_LAMBDA_GETSIGNEDURL_DOWNLOAD_ENDPOINT
    let payload = {
      fileKey: fileKey
    }
    return axios.post(endpoint, payload)
      .then((res) => {
        return Promise.resolve(res.data.body.url || '/')
      })
      .catch((err) => {
        return Promise.reject('/')
      })
  }
}


// WEBPACK FOOTER //
// ./src/lambda.js